
import { defineComponent } from "vue";
import IconEmail from "./icon/Email.vue";
import IconGithub from "./icon/Github.vue";
import IconLinked from "./icon/Linked.vue";

export default defineComponent({
  components: { IconLinked, IconGithub, IconEmail },
});
